'usr strict';

import controller from './avance-proyecto.controller';
import template from './avance-proyecto.html';

const AvanceProyectoComponent = {
  bindings: {},
  controller,
  template
};

export default AvanceProyectoComponent;



// WEBPACK FOOTER //
// ./src/app/components/reg-empresas/avance-proyecto/avance-proyecto.component.js